export class UserExportVO {
    userName: string;
    teamId: number;

    constructor(userName, teamId) {
        this.userName = userName;
        this.teamId = teamId;
    }
}



// WEBPACK FOOTER //
// ./src/app/model/user-export-vo.ts